import { render, staticRenderFns } from "./assignOffice.vue?vue&type=template&id=71d3b5fd&"
import script from "./assignOffice.vue?vue&type=script&lang=js&"
export * from "./assignOffice.vue?vue&type=script&lang=js&"
import style0 from "./assignOffice.vue?vue&type=style&index=0&id=71d3b5fd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports